import { numericKeys, actionsKeys } from './constants';

export const availableNumerics = [
  numericKeys.KEY_ZERO,
  numericKeys.KEY_ONE,
  numericKeys.KEY_TWO,
  numericKeys.KEY_THREE,
  numericKeys.KEY_FOUR,
  numericKeys.KEY_FIVE,
  numericKeys.KEY_SIX,
  numericKeys.KEY_SEVEN,
  numericKeys.KEY_EIGHT,
  numericKeys.KEY_NINE,
];

export const availableDirections = [
  actionsKeys.KEY_UP,
  actionsKeys.KEY_DOWN,
  actionsKeys.KEY_RIGHT,
  actionsKeys.KEY_LEFT,
  actionsKeys.KEY_ENTER,
  actionsKeys.KEY_BACK,
];

export const availableActions = [
  ...availableNumerics,
  ...availableDirections,
  actionsKeys.KEY_RED,
  actionsKeys.KEY_GREEN,
  actionsKeys.KEY_YELLOW,
  actionsKeys.KEY_BLUE,
  actionsKeys.KEY_PLAY,
  actionsKeys.KEY_PAUSE,
  actionsKeys.KEY_REWIND,
  actionsKeys.KEY_FASTFORWARD,
  actionsKeys.KEY_STOP,
  actionsKeys.KEY_SPACE,
  actionsKeys.KEY_REWIND_LONGPRESS,
  actionsKeys.KEY_FASTFORWARD_LONGPRESS,
];
